module.exports = __webpack_public_path__ + "static/comienzo-75567decd63189c6f3cfb364c86c004f.jpg";